module.exports = __webpack_public_path__ + "static/media/usMortSpl-banner.4e6e4238.jpg";